<div class="container-fluid d-flex align-items-center justify-content-center">
    <div class="login-card text-center">
        <!-- White header for logo visibility -->
        <div class="landing-header">
            <img src="./../../../../assets/images/pmi_logo.png" 
                 class="login-logo mb-3 mx-auto d-block" 
                 alt="PMI Logo">
            <h2 class="landing-title">Welcome to STDG</h2>
            <p class="landing-subtitle">Synthetic Test Data Generator</p>
        </div>
        
        <div class="auth-wrapper">
            <div class="d-grid gap-3">
                <button type="button" 
                        class="btn btn-primary auth-button"
                        (click)="goToLogin()">
                    <i class="bi bi-shield-lock-fill"></i>
                    Login to Get Started
                </button>
                
                <div class="d-flex flex-column gap-2 mt-3">
                    <a href="https://wiki.app.pconnect.biz/display/TPA/Approve+STDG+-+Synthetic+Test+Data+Generation-+Solution+Outline" 
                       target="_blank"
                       class="text-decoration-none auth-footer-link">
                        STDG Solution Outline
                    </a>
                    <a href="https://wiki.app.pconnect.biz/display/OPD/STDG+-+User+Guide" 
                       target="_blank"
                       class="text-decoration-none auth-footer-link">
                        STDG Playbook
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div>
  <router-outlet></router-outlet>